module.exports = __webpack_public_path__ + "img/checkBoxOff.ee4d0a0a.svg";